<template>
  <div class="GlobalFormDemo">
    <GlobalForm ref="orderForm" :init-data="initData" :form-item-list="formItemList" :inline="true"
      :isResetdata="isResetForm" :labelWidth="80" round :needBtnLoading="true" @handleConfirm="handleConfirm"
      confirmBtnName="查询">
      <el-form-item label-width="70px" label="门店商户" slot="contractType" style="margin: 0">
        <el-select v-model="companyIds" placeholder="请选择门店商家" filterable clearable multiple>
          <el-option v-for="item in merchantSelectList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label-width="'80px'" label="回收分类" slot="typeId" style="margin: 0">
        <el-select clearable @change="recoverySeparator" v-model="typeId">
          <el-option v-for="item in classList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label-width="'80px'" label="回收品牌" slot="brandNo" style="margin: 0">
        <el-select clearable filterable v-model="brandNo">
          <el-option v-for="item in brandNoListData" :key="item.id" :label="item.name" :value="item.brandNo">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label-width="'100px'" label="回收商品" slot="phoneName" style="margin: 0">
        <el-select placeholder="请先选择分类" filterable :disabled="!typeId" clearable remote :remote-method="remoteMethod"
          v-model="modelCode">
          <el-option v-for="item in modelListData" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="实际机况" slot="Computer" style="margin: 0">
        <el-select v-model="healthCode" placeholder="请选择实际机况" clearable>
          <el-option v-for="item in cupatList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单状态" slot="state" style="margin: 0">
        <el-select v-model="state" placeholder="请选择订单状态" clearable multiple>
          <el-option v-for="item in orderStatusList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="el_from select_down" label="开机情况" slot="signatoryId" style="margin: 0">
        <el-select :popper-append-to-body="false" v-model="openMachineCondition" placeholder="请选择" clearable>
          <el-option v-for="item in machineType" :key="item.merchantId" :label="item.merchantName"
            :value="item.merchantId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label-width="70px" label="成色等级" slot="finenessHealthCode" style="margin: 0">
        <el-select :popper-append-to-body="false" v-model="finenessHealthCode" placeholder="请选择" clearable filterable
          multiple>
          <el-option v-for="item in levelcolorList" :key="item.value" :label="item.key" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label-width="70px" label="故障项" slot="signatoryName" style="margin: 0">
        <el-cascader v-model="failureIds" :options="failureTypeList" :show-all-levels="false" :props="props"
          collapse-tags></el-cascader>
      </el-form-item>
      <!-- <el-form-item label-width="90px" label="sku对比情况" slot="sku" style="margin: 0">
        <el-select :popper-append-to-body="false" v-model="sku" placeholder="请选择" clearable filterable multiple>
          <el-option v-for="item in skuList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label-width="90px" label="是否识图" slot="isAiIdentify" style="margin: 0">
        <el-select :popper-append-to-body="false" v-model="isAiIdentify" placeholder="请选择" clearable filterable>
          <el-option v-for="(item, index) in recogimgList" :key="index" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label-width="90px" label="识图标签" slot="tagIdList" style="margin: 0">
        <el-select :popper-append-to-body="false" v-model="tagIdList" placeholder="请选择" clearable filterable multiple>
          <el-option v-for="item in imglabelList" :key="item.key" :label="item.value" :value="item.key">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label-width="90px" label="sku校验" slot="verifyList" style="margin: 0">
        <el-cascader v-model="skus" :options="skusList" :show-all-levels="false" clearable :props="props2"
          @change="handleChange1"></el-cascader>
      </el-form-item>
      <el-form-item label-width="120px" label="开机亮屏照识别" slot="sku" style="margin: 0">
        <el-cascader v-model="screenPhotos" :options="screenPhotosList" :show-all-levels="false" :props="props1"
          collapse-tags clearable @change="handleChange"></el-cascader>
      </el-form-item>
      <el-form-item label="下单时间" slot="entryTime" style="margin: 0">
        <el-date-picker v-model="entryTime" type="daterange" start-placeholder="开始日期" range-separator="~"
          end-placeholder="结束日期" clearable :default-time="['00:00:00', '23:59:59']">
        </el-date-picker>
      </el-form-item>
    </GlobalForm>
  </div>
</template>

<script>
import moment from "moment";
import _api from "@/utils/request";
import { _http } from "@/utils/request/bill";
import { http } from "@/utils/request/compositionRule";
export default {
  name: "Form",
  props: {
    default: () => {
      return [];
    },
    tabIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      openMachineCondition: "",
      talldifferencevalue: "",
      lowDifferencevalue: "",
      rangeIndex: "",
      cupatList: [{ id: "Nice", name: "靓机" }, { id: "Little_Snow", name: "小花" }, { id: "Big_Snow", name: "大花" }, { id: "Out_Burst", name: "外爆" }, { id: "Inner_Burst", name: "内爆" }, { id: "Other", name: "其他" }],
      tallPrice: "",
      shortPrice: "",
      ulPricedata: [],
      uprePrice: "",
      lowPrice: "",
      isResetForm: false,
      state: [], //订单状态
      companyId: [],
      companyList: [],
      entryTime: null,
      initData: {},
      startTime: "",
      endTime: "",
      formItemList: [
        {
          key: "orderNo",
          type: "input",
          labelName: "订单编号",
          placeholder: "请输入订单编号",
        },
        {
          key: "imei",
          type: "input",
          labelName: "串号",
          placeholder: "请输入串号查询",
          lableWidth: "50px",
        },
        { slotName: "contractType" },
        { slotName: "typeId" },
        { slotName: "brandNo" },
        { slotName: "phoneName" },
        { slotName: "state" },
        { slotName: 'signatoryId' },
        { slotName: "Computer" },
        { slotName: "finenessHealthCode" },
        { slotName: 'signatoryName' },
        // { slotName: "sku" },
        { slotName: 'isAiIdentify' },
        { slotName: "tagIdList" },
        { slotName: "verifyList" },
        { slotName: "sku" },
        { slotName: "entryTime" }, //下单时间
      ],
      SeachParams: {},
      classList: [],
      typeId: "",
      healthCode: "",
      modelCode: "",
      brandNo: "",
      modelListData: [],
      brandNoListData: [],
      orderStatusList: [],
      companyIds: [],
      goodsStateList: [],
      machineType: [{ merchantId: 'canStart', merchantName: "正常开机" }, { merchantId: 'unStart', merchantName: "无法开机" }, { merchantId: 'brand-new', merchantName: "全新机" }, { merchantId: 'elderly', merchantName: "功能机/老年机" }],
      finenessHealthCode: [],
      levelcolorList: [],
      failureIds: [],
      failureTypeList: [],
      sku: "",
      skuList: [{ id: 1, name: "未比对" }, { id: 2, name: "机型一致,容量一致" }, { id: 3, name: "机型一致,容量不一致" }, { id: 4, name: "机型不一致,容量一致" }, { id: 5, name: "机型容量都不一致" }],
      isAiIdentify: "",
      recogimgList: [{ id: true, name: "已识图" }, { id: false, name: "未识图/部分失败" }],
      tagIdList: [],
      imglabelList: [],
      merchantSelectList: [],
      props: { multiple: true, emitPath: false, },
      skus: [],
      skusList: [{ value: "00", label: "无需校验" }, { value: "01", label: "需校验", children: [{ value: "01", label: "机型一致" }, { value: "02", label: "机型不一致" }, { value: "00", label: "机型未识别" }] }],
      props1: {
        multiple: true,
        checkStrictly: true,

      },
      props2: {
        multiple: true,
        checkStrictly: true,

      },
      screenPhotos: [],
      screenPhotosList: [{ value: "00", label: "无需校验" }, { value: "01", label: "需校验", children: [{ value: "01", label: "校验通过" }, { value: "02", label: "校验失败" }, { value: "00", label: "未识别" }] }],
      selectedValues: [],
      lightScreenValidType: "",
      lightScreenCompares: [],
      selectedValues1: [],
      skuValidType: [],
      modelCompares: []
    };
  },
  created() {
    http.healthList({ isIncludeRisk: false }).then(res => {
      this.levelcolorList = res.data
    })
    _http.findTreeFailure2().then((res) => {
      console.log(res, "的合格合格符合")
      this.failureTypeList = res.data;
    });
    _api.getSelectList().then((res) => {
      if (res.code === 1) {
        console.log('===', res);
        this.merchantSelectList = res.data;
      }
    });
    let startTime = moment().format("YYYY-MM-DD 00:00:00"); // 当前时间往前推7天的时间
    let endTime = moment().format("YYYY-MM-DD 23:59:59");
    this.entryTime = [startTime, endTime];
    this.getClassList();
    this.getStatusList();
    this.getDetectionCategory()
    _api.tagselected().then((res) => {
      console.log(res, "识图标签")
      if (res.code === 1) {
        this.imglabelList = res.data;
      }
    });
    _api.orderStatusList().then((res) => {
      let arr = [];
      for (const item of res.data) {
        arr.push({
          value: item.key,
          label: item.value,
        });
      }
      this.orderStatusList = arr;
    });
  },
  mounted() {
    this.handleConfirm({ orderNo: "" });
  },
  methods: {
    getDetectionCategory() {
      // _api.getFailureType().then((res) => {
      //   this.failureTypeList = res.data;
      // });
    },
    // 获取下拉数据
    getStatusList() {
      //品牌
      _api.oldBrandSelectList().then((res) => {
        if (res.code === 1) {
          this.brandNoListData = res.data;
        }
      });
    },
    //通过分类请求机型
    getlistSelected(id, name) {
      _api
        .getlistSelected({
          machineTypeId: id,
          name,
        })
        .then((res) => {
          if (res.code === 1) {
            this.modelListData = res.data;
          }
        });
    },
    remoteMethod(name) {
      this.getlistSelected(this.typeId, name);
    },
    //回收分类选择
    recoverySeparator(e) {
      console.log(e);
      this.modelCode = "";
      if (e) {
        this.getlistSelected(e);
      }
    },
    // 获取分类集合
    getClassList() {
      _api.selectList().then((res) => {
        this.classList = res.data || [];
      });
    },
    //查询****
    handleConfirm(data, cd) {
      console.log("提交了form", data);
      console.log(this.entryTime, "时间");
      if (this.entryTime === null) {
        this.startTime = "";
        this.endTime = "";
      } else {
        this.startTime = moment(this.entryTime[0]).format("x");
        this.endTime = moment(this.entryTime[1]).format("x");
      }
      const baseRequest = {
        orderNo: data.orderNo,
        imei: data.imei,
        companyIds: this.companyIds,
        typeId: this.typeId,
        modelCode: this.modelCode,
        brandNo: this.brandNo,
        state: this.state,
        openMachineCondition: this.openMachineCondition,
        healthCode: this.healthCode,
        finenessHealthCode: null,
        finenessHealthCodes: this.finenessHealthCode,
        failureIds: this.failureIds,
        // sku:this.sku,
        isAiIdentify: this.isAiIdentify,
        tagIdList: this.tagIdList,
        endTime: this.endTime,
        startTime: this.startTime,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        lightScreenValidType: this.lightScreenValidType[0],
        lightScreenCompares: this.lightScreenCompares,
        skuValidType: this.skuValidType[0],
        modelCompares: this.modelCompares,
        disuseLoding: () => {
          if (typeof cd === 'function') {
            cd();
          }
        },
      };

      this.SeachParams = baseRequest;
      this.$store.commit("tagsView/SEACH_PARAMS", baseRequest);
    },
    handleChange(value) {
      console.log(value, "value")
      let a = false
      let b = null
      console.log(this.screenPhotos, "this.screenPhotos")
      if (this.selectedValues.length === 0) {
        this.screenPhotos = value
      }
      else {
        this.screenPhotos.forEach(item => {
          if (item[0] !== this.selectedValues[0][0]) {
            a = true
            b = item
          }
          else if (!item[1] && this.selectedValues[0][1]) {
            a = true
            b = item
          }
          else if ((!item[2] && this.selectedValues[0][2]) || (item[2] && this.selectedValues[0][2])) {
            a = true
            b = item
          }
        })
      }
      if (a) {
        this.screenPhotos = []
        this.screenPhotos.push(b)
      }
      this.selectedValues = this.screenPhotos
      console.log(this.selectedValues, "selectedValues")
      let lsarry = []
      let arry = []
      this.selectedValues.forEach(item => {
        if (item[0]) {
          arry.push(item[0])
        }
        if (item.length == 2) {
          lsarry.push(item[1])
        }
        if (item.length == 3) {
          lsarry.push(item[2])
        }
      })
      let lightScreenValidType = arry.reduce((acc, current) => {
        if (!acc.has(current)) {
          acc.add(current);
        }
        return acc;
      }, new Set());

      this.lightScreenValidType = Array.from(lightScreenValidType);
      this.lightScreenCompares = lsarry
      // console.log(this.lightScreenCompares, "lightScreenCompares")
      // console.log(this.lightScreenValidType, "lightScreenValidType")
    },
    handleChange1(value) {
      console.log(value, "value")
      let a = false
      let b = null
      if (this.selectedValues1.length === 0) {
        this.skus = value
      }
      else {
        this.skus.forEach(item => {
          if (item[0] !== this.selectedValues1[0][0]) {
            a = true
            b = item
          }
          else if (!item[1] && this.selectedValues1[0][1]) {
            a = true
            b = item
          }
          else if ((!item[2] && this.selectedValues1[0][2]) || (item[2] && this.selectedValues1[0][2])) {
            a = true
            b = item
          }
        })
      }
      if (a) {
        this.skus = []
        this.skus.push(b)
      }
      this.selectedValues1 = this.skus
      console.log(this.selectedValues1, "selectedValues1")
      let lsarry = []
      let arry = []
      this.selectedValues1.forEach(item => {
        if (item[0]) {
          arry.push(item[0])
        }
        if (item.length == 2) {
          lsarry.push(item[1])
        }
        if (item.length == 3) {
          lsarry.push(item[2])
        }
      })
      let skuValidType = arry.reduce((acc, current) => {
        if (!acc.has(current)) {
          acc.add(current);
        }
        return acc;
      }, new Set());

      this.skuValidType = Array.from(skuValidType);
      this.modelCompares = lsarry
      console.log(this.modelCompares, "modelCompares")
      console.log(this.skuValidType, "skuValidType")
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.top_aujian {
  overflow: auto;
  width: 225px;
  height: 200px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.ta_center_con {
  cursor: pointer;
  text-align: center;
  line-height: 30px;
  font-size: 14px;
  font-family: FZLanTingHei-M-GBK;
  font-weight: 400;
  margin-bottom: 14px;
  color: #333333;
  width: 100px;
  height: 30px;
  background: #f3f3f3;
  border-radius: 4px;
}

.ta_center_action {
  cursor: pointer;
  text-align: center;
  line-height: 30px;
  font-size: 14px;
  font-family: FZLanTingHei-M-GBK;
  font-weight: 400;
  margin-bottom: 14px;
  color: #0981ff;
  width: 100px;
  height: 30px;
  background: #e4ecfd;
  border-radius: 4px;
}

/deep/.query .el-tag.el-tag--info {
  background-color: #fbfbfb;
  border-color: #cecdcd;
  color: #666666;
}

.baoPrice {
  border: 1px solid #e4ecfd;
  width: 421px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  border-radius: 20px;
  padding: 3px 10px;

  >img {
    width: 15px;
    height: 15px;
  }
}

.bao_section {
  flex: 1;
  font-size: 12px;
  font-family: FZLanTingHei-M-GBK;
  font-weight: 400;
  color: #a1a4af;
  // width: 300px;
  align-items: center;
  justify-content: space-evenly;
  display: flex;
}

.pulldown_content {
  width: 265px;
  padding: 0 20px;
  height: 300px;
  position: relative;
}

.fc_input {
  font-size: 12px;
  font-family: FZLanTingHei-M-GBK;
  font-weight: 400;
  color: #333333;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 15px auto;
  width: 225px;
  height: 30px;
  // background: #F9FBFD;
  border: 1px solid #c1d1ff;
  border-radius: 4px;
}

.put_price {
  width: 80px;

  /deep/.el-input__inner {
    border: none !important;
  }
}

.foot_content {
  position: absolute;
  bottom: 0;
  width: 225px;
  height: 95px;
  // box-shadow: 0px 2px 14px 1px rgba(118, 133, 164, 0.31);
}

/deep/.el-dropdown-menu__item {
  line-height: 30px !important;
  padding: 0 !important;
}

.pc_footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.GlobalFormDemo {
  /deep/.el-checkbox-group {
    margin-left: 15px;
  }

  // /deep/.el-form-item--small.el-form-item{
  //   margin-bottom: 0;
  // }
  .flex {
    display: flex;
    align-items: center;
  }

  .time-type {
    /deep/.el-input__inner {
      border: none;
    }
  }
}

/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

/deep/ input[type="number"] {
  -moz-appearance: textfield;
}
</style>